import { render, staticRenderFns } from "./WtActionMenu.vue?vue&type=template&id=22d39a58&scoped=true&lang=pug&"
import script from "./WtActionMenu.vue?vue&type=script&lang=js&"
export * from "./WtActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./WtActionMenu.vue?vue&type=style&index=0&id=22d39a58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d39a58",
  null
  
)

export default component.exports